import CheckIcon from "@mui/icons-material/Check";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import WarningIcon from "@mui/icons-material/Warning";
import { StatusQuoteImportEnum } from "@/main/services/enum/StatusQuoteImportEnum";
import * as S from "./styles";
import colors from "@/main/style/colors";
import TooltipComponent from "@/main/components/shared/tooltip/tooltipComponent";
import { IconButton } from "@mui/material";

interface IFileStatus {
	idFileStatus: StatusQuoteImportEnum;
	title?: string;
	messageTooltip?: string;
	onCustomClick?: () => void;
}

function FileStatus({ idFileStatus, title = "", messageTooltip = "", onCustomClick = () => {} }: IFileStatus) {
	const theme = colors;

	const RenderIcon = () => {
		switch (idFileStatus) {
			case StatusQuoteImportEnum.Success:
				return (
					<S.Container title={title}>
						<CheckIcon fontSize="small" style={{ color: theme.green }} />
					</S.Container>
				);
			case StatusQuoteImportEnum.Failed:
				return (
					<TooltipComponent placement="top" title={messageTooltip}>
						<IconButton onClick={() => onCustomClick()}>
							<WarningIcon fontSize="small" style={{ color: theme.red }} />
						</IconButton>
					</TooltipComponent>
				);
			case StatusQuoteImportEnum.Pending:
				return (
					<S.Container title={title}>
						<QueryBuilderIcon fontSize="small" style={{ color: theme.orange }} />
					</S.Container>
				);
			default:
				return null;
		}
	};
	return <RenderIcon />;
}

export default FileStatus;
